import * as React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { SelectChangeEvent } from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import PhoneIcon from "@mui/icons-material/Phone";
import Viber from "assets/icons/Viber";
import TelegramIcon from "@mui/icons-material/Telegram";

interface Option {
  name: string | number;
  value?: string;
  label?: string;
  icon?: any;
}

interface CustomSelectComponentProps {
  value: string;
  onChange?: (event: SelectChangeEvent<unknown>, child: React.ReactNode) => void;
}

const CustomFormControl = styled(FormControl)<{}>(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    width: 90,
    height: 40,
    borderRadius: "8px",
    borderColor: "transparent",
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: "transparent",
    },
    "&.Mui-focused fieldset": {
      borderColor: "transparent",
    },
  },
}));

const CustomSelect = styled(Select)<{}>(({ theme }) => ({
  height: 40,
  backgroundColor: "#F6F7F9",
  "& .MuiSelect-select": {
    display: "flex",
    fontSize: "14px",
    lineHeight: 1.43,
    fontFamily: "var(--cygreRegular), sans-serif",
    color: "#2E263D",
    padding: "0px 16px",
  },
  "& .MuiSelect-icon": {
    color: "#6D6777",
  },
}));

const SocialMediaSelect: React.FC<CustomSelectComponentProps> = ({ value, onChange }) => {
  const socialMediaOptions: Option[] = [
    { name: "Telegram", value: "telegram", label: "Telegram", icon: <TelegramIcon /> },
    { name: "WhatsApp", value: "whatsapp", label: "WhatsApp", icon: <WhatsAppIcon /> },
    // { name: "Viber", value: "viber", label: "Viber", icon: <Viber /> },
    // { name: "Phone", value: "phone", label: "Phone", icon: <PhoneIcon /> },
  ];

  return (
    <Box sx={{ width: 90 }}>
      <CustomFormControl>
        <CustomSelect
          name="social-media"
          id="custom-select"
          value={value}
          renderValue={(selected) => {
            const sel = socialMediaOptions.find((option) => option.value === selected);
            if (sel?.icon) {
              return sel.icon;
            }
          }}
          onChange={onChange}
          inputProps={{ "aria-label": "social media select" }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            PaperProps: {
              sx: {
                borderRadius: "8px",
                marginTop: "8px",
                maxHeight: 320,
                "& .MuiMenu-list": {
                  padding: "0px !important",
                  width: "100% !important",
                },
              },
            },
          }}
        >
          {socialMediaOptions?.map((option: Option) => (
            <MenuItem
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontFamily: "var(--cygreRegular), sans-serif",
                color: "#000",
                fontSize: 14,
              }}
              key={option.value}
              value={option.value}
            >
              {option.icon}
              {option.label}
            </MenuItem>
          ))}
        </CustomSelect>
      </CustomFormControl>
    </Box>
  );
};

export default SocialMediaSelect;
